import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Per-page SEO + Open Graph tags. Defaults fall back to whatever index.html
 * shipped with — only override what you pass.
 *
 * `path` is the canonical path (e.g. `/wins`). The full URL is built off
 * `window.location.origin` at runtime so it works across preview / production.
 */
export default function Seo({
  title,
  description,
  path = "",
  image,
}) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const url = origin + path;
  const img = image || `${origin}/og-image.png`;
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {title && <meta property="og:title" content={title} />}
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="description" content={description} />}
      {description && <meta property="og:description" content={description} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:image" content={img} />
      <link rel="canonical" href={url} />
    </Helmet>
  );
}
